import { FIELDS_METADATA, WIZARD_FIELDS } from './creation-wizard-state.const';
import { ChooseInstallableForAppGetNextStep, CREATION_WIZARD_STEPS, FEATURE_TYPE_TO_STEP, CREATION_MODES } from './creation-wizard.const';
// Private
const getWorkflowCreationInitialWizardStep = (state) => {
	if (state.selectedFeatureTypeId && state.selectedAppId) {
		return ChooseInstallableForAppGetNextStep({ selectedApp: state.selectedApp }); // return CREATION_WIZARD_STEPS.CHOOSE_INSTALLABLE_FOR_ADD_ON; // TODO - remove comment after enabling installables mechanism
	}
	if (state.selectedFeatureTypeId && state.selectedToolPlacementId) {
		return CREATION_WIZARD_STEPS.FILL_TOOL_DATA;
	}
	if (state.selectedFeatureTypeId) {
		return FEATURE_TYPE_TO_STEP[state.selectedFeatureTypeId];
	}
	return CREATION_WIZARD_STEPS.CHOOSE_PROJECT_AND_FEATURE;
};

const getButtonDropdownCreationInitialWizardStep = (state) => {
	if (state.selectedAppId) {
		return CREATION_WIZARD_STEPS.CHOOSE_PLACEMENT_FOR_BUTTON_DROPDOWN;
	}
	return CREATION_WIZARD_STEPS.CHOOSE_APP_FOR_BUTTON_DROPDOWN;
};

const CREATION_INITIAL_WIZARD_STEP_HANDLERS = {
	[CREATION_MODES.WORKFLOW]: getWorkflowCreationInitialWizardStep,
	[CREATION_MODES.BUTTON_DROPDOWN]: getButtonDropdownCreationInitialWizardStep,
};

// Public
const getInitialWizardStep = (state) => CREATION_INITIAL_WIZARD_STEP_HANDLERS[state.mode](state);

/**
 * builds CreationWizard state by default values of fields in creation-wizard-state.const
 */
const getWizardState = () =>
	WIZARD_FIELDS.reduce((state, fieldName) => {
		const defaultValue = FIELDS_METADATA[fieldName]?.default();
		state[fieldName] = defaultValue !== undefined ? defaultValue : null;
		return state;
	}, {});

const CreationWizardService = { getInitialWizardStep, getWizardState };

export default CreationWizardService;
